import { render } from "./LitholamFlatbedDieCutter.vue?vue&type=template&id=1fad9639&scoped=true"
const script = {}

import "./LitholamFlatbedDieCutter.vue?vue&type=style&index=0&id=1fad9639&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fad9639"]])

export default __exports__